/*eslint-disable*/
import { AzureClient } from "@fluidframework/azure-client";
import { SharedMap } from "fluid-framework";
import api from "@/api";

const containerSchema = {
  initialObjects: {
    mindHistory: SharedMap,
    mindData: SharedMap,
    isDeleting: SharedMap,
    coworkMode: SharedMap,
  },
};

/**
 * 將目前 jsMind 資料複製為新心智圖文件並開啟
 * @param {object} jm - jsMind 實例
 * @param {object} profile - { teammodelId, name }
 * @param {string} mindmapName - 原始心智圖名稱
 * @param {string} copyLabel - 副本名稱後綴 (e.g. '副本')
 * @param {object|null} creatorInfo - 原始擁有者 { id, name }，用於補齊無 finalEditor 的節點
 * @returns {Promise<object>} 建立好的心智圖文件
 */
export async function copyMindMapToMyDocuments(jm, profile, mindmapName, copyLabel = '副本', creatorInfo = null) {
  const data = {
    mindmapName: `${mindmapName}（${copyLabel}）`,
    mindmapCreator: {
      id: profile.teammodelId,
      name: profile.name,
    },
    mindmapData: "",
    fluidContainerId: "",
    openCowork: false,
    coworkMode: "view",
  };

  const fluidConfig = await api.mindmapAPI.getFluidRelayConfig();
  const serverLocation = api.main.getServerLocation();
  const dataCenter = serverLocation.includes("cn") ? "china" : "global";
  localStorage.removeItem("cachedFluidRelayToken");

  const client = new AzureClient({
    connection: {
      type: "remote",
      tenantId: fluidConfig[dataCenter]?.fluidRelayTenantId,
      tokenProvider: new api.MyAzTokenProvider(api.mindmapAPI.fluidTokenUrl, {
        idToken: "",
        id: profile.teammodelId,
        name: profile.name,
      }),
      endpoint: fluidConfig[dataCenter]?.fluidRelayEndpoint,
    },
  });

  const { container } = await client.createContainer(containerSchema, "2;");
  data.fluidContainerId = await container.attach();

  const jsmindArrData = jm.get_data("node_array");
  const newMindmapName = data.mindmapName;
  const fallbackEditor = creatorInfo ? { seat: creatorInfo.id, name: creatorInfo.name } : null;
  const updatedItems = jsmindArrData.data.map(item => {
    const nodeData = item.data ? { ...item.data } : {};
    if (!nodeData.finalEditor && fallbackEditor) nodeData.finalEditor = fallbackEditor;
    if (item.isroot || item.id === 'root') {
      return { ...item, topic: `<p>${newMindmapName}</p>`, data: { ...nodeData, nodeText: newMindmapName } };
    }
    return { ...item, data: nodeData };
  });
  const mindDataShared = container.initialObjects.mindData;
  await Promise.all(updatedItems.map(item => mindDataShared.set(item.id, JSON.stringify(item))));
  container.initialObjects.isDeleting.set('data', false);
  container.initialObjects.coworkMode.set('data', JSON.stringify({ coworkMode: "view", openCowork: false }));

  const res = await api.mindmapAPI.createMindMap(data);
  return res;
}
